import { SVGFC } from '@repo/toolkit/types'

const DotIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.00098 12.9994C11.2101 12.9994 13.001 11.2085 13.001 8.99939C13.001 6.79025 11.2101 4.99939 9.00098 4.99939C6.79184 4.99939 5.00098 6.79025 5.00098 8.99939C5.00098 11.2085 6.79184 12.9994 9.00098 12.9994Z"
        fill={color}
      />
    </svg>
  )
}

export default DotIcon
